import React from 'react';
import Header from 'src/components/Header';

import { useAppStateContext } from 'src/AppState/AppState';
import { AnniversaryModal } from 'src/components/AnniversaryModal/AnniversaryModal';
import { Events } from 'src/domains/sportsbook/trading/view/eventDetails/Events';
import { ComplianceAudits } from 'src/components/ComplianceAudits/ComplianceAudits';
import { TradingContent } from 'src/layouts/TradingPage/TradingContent';
import { TradingMenuItems } from 'src/layouts/TradingPage/TradingMenuItems';
import { observer } from 'src/utils/mobx-react';
import { LayoutWrapper, MainContainer } from 'src/domains/layouts/shared/layout/Layout.style';
import { EventsTrigger } from 'src/components/EventsTrigger/EventsTrigger';
import { PepXmlRouterWrapper } from 'src/components/FraudAndCompliance/PEPTab/PEP/PepXml/PepXml';
import CustomersBar from 'src/components/CustomersBar';
import Audits from 'src/components/Audits';
import { AuditIdMission } from 'src/components/AuditIdMission/AuditIdMission';

const AnniversaryModalWrapper = observer('AnniversaryModalWrapper', () => {
    const { localStorageState } = useAppStateContext();
    const showAnniversaryModal = localStorageState.anniversaryInfoLocalStorage;

    return showAnniversaryModal ? <AnniversaryModal /> : null;
});

export const TradingPage = observer('TradingPage', () => (
    <LayoutWrapper>
        <AnniversaryModalWrapper />
        <Header />

        <MainContainer>
            <TradingMenuItems />
            <TradingContent />
        </MainContainer>

        <CustomersBar />
        <EventsTrigger />
        <Events />
        <Audits />
        <ComplianceAudits />
        <AuditIdMission />
        <PepXmlRouterWrapper />
    </LayoutWrapper>
));
